import type { HTMLAttributes } from 'react';
import styles from './Skeleton.module.css';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
    variant?: 'rectangle' | 'circle' | 'text';
    width?: string | number;
    height?: string | number;
    className?: string;
}

export function Skeleton({
    variant = 'rectangle',
    width,
    height,
    className,
    style,
    ...props
}: SkeletonProps) {
    const classes = [
        styles.skeleton,
        styles[variant],
        className,
    ].filter(Boolean).join(' ');

    const customStyle = {
        ...style,
        width: width,
        height: height,
    };

    return (
        <div
            className={classes}
            style={customStyle}
            {...props}
        />
    );
}

Skeleton.displayName = 'Skeleton';
